import { POLL_TYPE } from 'wix-rich-content-common';
import { queryMembers } from '@wix/ambassador-members-v1-member/http';
import { PollsService } from './PollsService';
import DataLoader from 'dataloader';
const isSSR = () => typeof window === 'undefined';
const fetchMembers = (membersIds, instance, getHttpClientPromise) => getHttpClientPromise().then(httpClientInstance => {
    const membersPromise = httpClientInstance
        .request(queryMembers({ query: { filter: { id: { $in: membersIds } } } }), {
        signedInstance: instance,
    })
        .then(res => {
        if (res.status === 200) {
            return res?.data?.members || [];
        }
        else {
            throw res.statusText;
        }
    })
        .catch(e => {
        // TODO: fix api for EditorX
        // eslint-disable-next-line no-console
        console.error('[pollsStrategy] fetchMembers failed. error:', e);
        return [];
    })
        .then(normalizeMembers);
    return membersPromise;
});
// caching per module will solve fetching of members per each viewer
const membersCache = new Map();
function createMembersLoader(loadMembers) {
    return new DataLoader((memberIds) => {
        return loadMembers(memberIds).then(memberList => memberIds.map(id => memberList.find(m => m.siteMemberId === id) || new Error('Member not found')));
    }, { cacheMap: membersCache });
}
const normalizeMembers = (rawMembers) => rawMembers?.map?.(member => {
    return {
        siteMemberId: member.id ?? undefined,
        imageUrl: member.profile?.photo?.url ?? undefined,
        name: {
            nick: member.profile?.nickname ?? undefined,
        },
    };
});
// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export default function pollsStrategy(instance, getHttpClientPromise) {
    if (!instance) {
        return {};
    }
    // TODO: trigger getSiteMembers & fetch inside polls and wait for response
    const getSiteMembers = isSSR()
        ? undefined
        : (() => {
            const loader = createMembersLoader(async (memberIds) => {
                const members = await fetchMembers(memberIds, instance, getHttpClientPromise);
                return memberIds.map(id => members.find(m => m.siteMemberId === id) || {
                    // We fallback to private member if member not found, or we have fetch error for now.
                    siteMemberId: id,
                });
            });
            return loader.loadMany.bind(loader);
        })();
    return {
        config: {
            [POLL_TYPE]: {
                pollServiceApi: new PollsService(instance, getHttpClientPromise),
                siteToken: instance,
                getSiteMembers,
            },
        },
    };
}
//# sourceMappingURL=pollsStrategy.js.map